import { render, staticRenderFns } from "./ErrorSubmitManualForm.vue?vue&type=template&id=4b7e2d24&scoped=true"
import script from "./ErrorSubmitManualForm.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitManualForm.vue?vue&type=script&lang=ts"
import style0 from "./ErrorSubmitManualForm.vue?vue&type=style&index=0&id=4b7e2d24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e2d24",
  null
  
)

export default component.exports